export default class MapsLoader {
    getOptions() {
        const options = {
            center: {lat: 0, lng: 0},
            zoom: 3,
            minZoom: 2,
            key: myApp.config.parameters.googleMapsApiKey,
            v: "weekly",
            libraries: ["geometry", "marker", "cluster"],
            mapId: myApp.config.parameters.googleMapsId,
            gestureHandling: 'greedy',
            clickableIcons: false,
            fullscreenControl: false,
            restriction: {
                latLngBounds: {north: 85, south: -85, west: -180, east: 180},
                strictBounds: true
            },
            mapTypeControl: false
        }

        if (myApp.deviceDetector.isXsScreen()) {
            options.zoomControlOptions = {position: google.maps.ControlPosition.LEFT_TOP};
            options.streetViewControlOptions = {position: google.maps.ControlPosition.LEFT_TOP};
        } else {
            options.mapTypeControlOptions = {position: google.maps.ControlPosition.BOTTOM_LEFT};
        }

        return options;
    }
}
